
define('text!modules/creatives/bulkedit/templates/change_grid_item.html',[],function () { return '<div class="item">\n\t<div class="column field">{{field}}</div>\n\t<div class="column value">{{value}}</div>\n</div>';});

